import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[psUiAlertContent], ps-ui-alert-content',
})
export class AlertContentDirective {
  @HostBinding('class.alert-content') readonly _defaultClass = true;
}
